import React, {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {ContextAuth} from '../../../common/context/context-auth';
import {useHttpClient} from '../../../common/hook/http';
import {useToast} from '../../../common/hook/toast';

import NoContent from '../../../common/component/NoContent/NoContent';
import Loader from '../../../common/component/Loader/Loader';

import GlobalConst from '../../../common/global-const';

import {Container, Row, Col, Button} from 'react-bootstrap';

import {ReactComponent as ImgTicket} from '../../../asset/img/icon/ticket.svg';

import './Entertain.scss';

const Entertain = () => {
    const {callAPI} = useHttpClient()
    const auth = useContext(ContextAuth)
    const {callToast} = useToast()

    // ------------------------------------------------------------------------------------------------------ fetch data

    const [data, setData] = useState(null)

    useEffect(() => {

        const fetchData = async () => {
            try {
                const responseData = await callAPI(
                    `entertainment`
                );

                // console.log(responseData)

                if (responseData.message) {

                } else {

                    setData(responseData.result.entertainments)

                }

            } catch (e) {
                console.error(e);
            }
        }

        fetchData()

    }, []);

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageEntertain" className="has-page-footer">
            {
                data ? (
                    data.length ? (
                        <>
                            <Container fluid as="section" id="box" className="px-0">
                                <Row className="justify-content-start align-items-start g-0">
                                    {
                                        data.map(item => {
                                            return (
                                                <Col md={6} key={item.id}>
                                                    <Link to={`/entertain/${item.id}`} className="ratio ratio-2x1">
                                                        <figure className="mb-0 bg-primary z-index-n1 filter-warm">
                                                            <span className="filter-level"/>
                                                            {
                                                                item.photos[0] ? (
                                                                    <img src={`${GlobalConst.cdn}${item.photos[0].path}`} alt="" className="h-100 w-100 object-fit-cover"/>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                            <span className="filter-gradient"/>
                                                        </figure>
                                                        <span className="p-4 d-flex flex-column justify-content-end align-items-start text-white">
                                                            <span className="h1 fw-bold mb-3">{item.name}</span>
                                                            <Button type="button" variant="outline-light">مشاهده</Button>
                                                        </span>
                                                    </Link>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </Container>
                            {/*<Container as="section" fluid="lg" className="page-footer">*/}
                            {/*    <Row>*/}
                            {/*        <Col xs={12} className="py-2 d-grid">*/}
                            {/*            {*/}
                            {/*                auth.user ? (*/}
                            {/*                    <Button as={Link} to={`/entertain/ticket-order`} className="my-1"><ImgTicket className="sw-1 me-2"/>{GlobalConst.buyTicketOnline}</Button>*/}
                            {/*                ) : (*/}
                            {/*                    <Button className="my-1" onClick={() => callToast('secondary', null, null, GlobalConst.loginFirst)}><ImgTicket className="sw-1 me-2"/>{GlobalConst.buyTicketOnline}</Button>*/}
                            {/*                )*/}
                            {/*            }*/}
                            {/*        </Col>*/}
                            {/*    </Row>*/}
                            {/*</Container>*/}
                        </>
                    ) : (
                        <div className="py-5 my-5">
                            <NoContent text={`اطلاعات وجود ندارد`}/>
                        </div>
                    )
                ) : (
                    <div className="py-5 my-5">
                        <Loader text="در حال دریافت اطلاعات"/>
                    </div>
                )
            }
        </div>
    )
}

export default Entertain;